import React from 'react';
import { AppBar, Toolbar, FormControl, Select, MenuItem, InputLabel, Box } from '@mui/material';
import translations from '../localizations';
import OpenRouterLimits from './OpenRouterLimits';

function TopBar({ language, setLanguage }) {
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <OpenRouterLimits />
        
        <FormControl variant="outlined" size="small">
          <InputLabel id="language-select-label">{translations[language].language}</InputLabel>
          <Select
            labelId="language-select-label"
            id="language-select"
            value={language}
            onChange={handleLanguageChange}
            label={translations[language].language}
          >
            <MenuItem value="vi">Tiếng Việt</MenuItem>
            <MenuItem value="en">English</MenuItem>
          </Select>
        </FormControl>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
